import PropTypes from "prop-types";

import ExtendedFieldsManager from "./ExtendedFieldsManager/ExtendedFieldsManager";
import ExtendedFieldsProvider from "./ExtendedFieldsProvider";

/**
 * The user interface for managing extended fields. Pass in a groupId to manage by group, or a signupListID for manage by signup.
 * @param {object} param0
 * @param {number} param0.groupId - the groupId this module should use when hitting endpoints
 * @param {number} param0.signupItemId - the id of the signup should this module be getting used for a signup instead of a group
 * @param {function} param0.syncEditing - pass in a function to be triggered whenever the user begins or ends editing a field. The first arg will be that Boolean value.
 * @param {boolean} param0.editWithModal - launches a modal when selecting or editing a field
 * @param {function} param0.syncHasExtendedFields - pass in a function to be triggered whenever the presence of any extended fields changes. The first arg will be that Boolean value.
 */
const ExtendedFields = ({
  groupId,
  signupItemId,
  syncNavigation,
  syncEditing,
  editWithModal,
  syncHasExtendedFields,
}) => (
  <ExtendedFieldsProvider
    groupId={groupId}
    signupItemId={signupItemId}
    editWithModal={editWithModal}
    syncNavigation={syncNavigation}
    syncEditing={syncEditing}
    syncHasExtendedFields={syncHasExtendedFields}
  >
    <ExtendedFieldsManager />
  </ExtendedFieldsProvider>
);

ExtendedFields.propTypes = {
  groupId: PropTypes.number,
  signupItemId: PropTypes.number,
  editWithModal: PropTypes.bool,
};

export default ExtendedFields;
